import React from 'react';

export function Interests() {
  return (
    <div className="interests">
      <section>
        В этом разделе должны быть мои интересы, но их не так много, поэтому
        постараюсь заполнить хотя бы одну строку:
      </section>
      <section>
        Фильмы, природа, наука, программирование, велоспорт, воллейбол.
      </section>
      <section>В будущем планирую добавить еще что-нибудь...</section>
    </div>
  );
}
